import { useCallback } from 'react';
import useProductListTopPosition from './useProductListPositionTopPosition';

export default function useScrollToTopOfProductList() {
    const productListTopPosition = useProductListTopPosition();

    const scrollToTopOfProductList = useCallback(() => {
        setTimeout(() => {
            window.scroll({
                top: productListTopPosition - 32, // 32px is just some padding
                behavior: 'smooth'
            });
        }, 200);
    }, [productListTopPosition]);

    return scrollToTopOfProductList;
}
